<template>
    <panel-template>
        <template #bradcrumbs>
            <ui-breadcrumbs design="full">
                <template #left>
                    Sem Permissão de Acesso
                </template>
            </ui-breadcrumbs>
        </template>

        <template #content>
            <div v-if="load" class="load">
                <ui-overlay-load />
            </div>

            <div v-else class="container-no-acess-permissions">
                <div class="container">
                    <div class="icon-lock">
                        <em class="fal fa-lock-alt" />
                    </div>

                    <span class="not-permissions">{{ details.title }}</span>

                    <span class="text-message">
                        {{ details.msg }}
                    </span>
                </div>
            </div>
        </template>
    </panel-template>
</template>

<script>
import { uiBreadcrumbs, uiOverlayLoad } from '@/components/ui';
import { alertMixin } from '@/mixins';
import { product } from '@/services/axios';
import PanelTemplate from '@/templates/page-panel-center';
import { mapGetters } from 'vuex';

export default {
    name: 'ui-no-access-permission',

    components: {
        PanelTemplate,
        uiBreadcrumbs,
        uiOverlayLoad
    },

	mixins: [
		alertMixin
	],

    data() {
        return {
            load: false,
            id: null
        }
    },

    computed: {
        ...mapGetters({
            details: 'detailsHasPermissions/getDetails'
        }),
    },

    async mounted() {
        this.id = this.$route.params.id
        console.log('this.id', this.id);
        if (this.id) {
            await this.loadMessage()
        } else {
            this.load = true

            setTimeout(() => {
                this.load = false
            }, 2000);
        }
    },

    methods: {
        async loadMessage() {
			this.load = true

            try {
				const response = await product.listProductConfiguration(this.id)
				this.details.msg = response.data?.data?.value?.message
				this.details.title = response.data?.data?.value?.title
				this.load = false
			} catch(error) {
				if (error.data?.msg) {
					this.$mx_alertError(error.data.msg)
				} else {
					this.$mx_alertError(error)
				}
				this.load = false
			} finally {
				this.load = false
			}
        }
    }
}
</script>

<style lang='stylus' scoped>
    @import './styles.styl'
</style>
